import { Helpers } from '../../helpers';
import { IItemRate } from '../../interfaces/iitem-rate';
import { GeneralAttributeRateKey } from '../general-attribute-rate-key';
import { Item } from '../item';
import { ItemAttributeRateKey } from '../item-attribute-rate-key';
import { ItemCategory } from '../item-category';
import { ItemRateTableName } from '../item-rate-table-name';
import { ItemSubCategory } from '../item-sub-category';
import { ScheduleTaskAttributeRateKey } from '../schedule-task-attribute-rate-key';

export class ItemRateBase {
  ItemRateId: number;
  ItemCategoryId: number | null;
  ItemNumber: number;
  EffectiveDate: Date | null;
  PriceBreakLow: number | null;
  PriceBreakHigh: number | null;
  Rate: number | null;
  ItemRateTableNameId: number | null;
  LastUpdatedDate: Date | null;
  LastUpdatedUser: string | null;
  ItemId: number | null;
  ItemSubCategoryId: number | null;
  IsActive: boolean;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  GeneralAttributeRateKeys_ItemRate?: Array<GeneralAttributeRateKey> | null;
  ItemAttributeRateKeys_ItemRate?: Array<ItemAttributeRateKey> | null;
  ScheduleTaskAttributeRateKeys_ItemRate?: Array<ScheduleTaskAttributeRateKey> | null;
  ItemCategory?: ItemCategory;
  Item?: Item;
  ItemRateTableName?: ItemRateTableName;
  ItemSubCategory?: ItemSubCategory;

  constructor(item?: IItemRate) {
    if (item) {

      this.ItemRateId = item.ItemRateId;
      this.ItemCategoryId = item.ItemCategoryId;
      this.ItemNumber = item.ItemNumber;
      this.EffectiveDate = item.EffectiveDate ? new Date(item.EffectiveDate) : null;
      this.PriceBreakLow = item.PriceBreakLow;
      this.PriceBreakHigh = item.PriceBreakHigh;
      this.Rate = item.Rate;
      this.ItemRateTableNameId = item.ItemRateTableNameId;
      this.LastUpdatedDate = item.LastUpdatedDate ? new Date(item.LastUpdatedDate) : null;
      this.LastUpdatedUser = item.LastUpdatedUser;
      this.ItemId = item.ItemId;
      this.ItemSubCategoryId = item.ItemSubCategoryId;
      this.IsActive = item.IsActive;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.GeneralAttributeRateKeys_ItemRate = Helpers.createClassArray(GeneralAttributeRateKey, item.GeneralAttributeRateKeys_ItemRate);
      this.ItemAttributeRateKeys_ItemRate = Helpers.createClassArray(ItemAttributeRateKey, item.ItemAttributeRateKeys_ItemRate);
      this.ScheduleTaskAttributeRateKeys_ItemRate = Helpers.createClassArray(ScheduleTaskAttributeRateKey, item.ScheduleTaskAttributeRateKeys_ItemRate);
      this.ItemCategory = new ItemCategory(item.ItemCategory);
      this.Item = new Item(item.Item);
      this.ItemRateTableName = new ItemRateTableName(item.ItemRateTableName);
      this.ItemSubCategory = new ItemSubCategory(item.ItemSubCategory);
    }
  }
}